import { Component, Input } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { NoticiaPage } from 'src/app/pages//noticia/noticia.page';
import { NoticiaDetalhesPage } from '../noticia-detalhes/noticia-detalhes.page';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ImagePipe } from 'src/app/pipes/image/image';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';

@Component({
  selector: 'lista-noticia',
  templateUrl: 'lista-noticia.html',
  styleUrls: ['lista-noticia.scss'],
  standalone: true,
  imports: [
    IonicModule,
    TranslateModule,
    CommonModule,
    ImagePipe,
    NomenclaturaPipe,
    DateFormatPipe
  ]
})
export class ListaNoticiaComponent {
  @Input()
  config: any;
  noticiaList: any = [];
  maximoNoticia: any = {
    maximo: false,
    maximoQtd: 0
  };

  constructor(public modalCtrl: ModalController) { }

  ngOnInit() {
    if (this.config.categoria.noticias.length > 6) {
      this.maximoNoticia.maximo = true;
      this.maximoNoticia.maximoQtd = this.config.categoria.noticias.length - 6;
    }

    this.noticiaList = this.config.categoria.noticias.slice(0, 6);
  }

  getFontColor() {
    return this.config.font_color;
  }

  async abrirNoticia(noticia: { id: string; }) {
    let modalPage = await this.modalCtrl.create({ component: NoticiaDetalhesPage, componentProps: { 'id': noticia.id } });
    modalPage.present();
  }

  async abrirCategoria() {
    let modalPage = await this.modalCtrl.create({ component: NoticiaPage, componentProps: { categorias: this.config.categoria.id, titulo: this.config.categoria.categoria } });
    modalPage.present();
  }

}
